(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eh-heel-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const link=event.target.closest('[data-eh-two-pairs]');if(!link)return;
const root=document.getElementById('eh-tcomprar');if(!root)return;
event.preventDefault();
const target=document.getElementById('eh-heel-buy')||root;
target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eh-talonera-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const link=event.target.closest('[data-eh-two-pairs]');if(!link)return;
const root=document.getElementById('eh-tcomprar');if(!root)return;
event.preventDefault();
const radio=Array.from(root.querySelectorAll('[data-opcion-input]')).find(input=>input.value.startsWith('2 pares'));
if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
const target=document.getElementById('eh-talonera-buy')||root;
target.focus({preventScroll:true});target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eh3-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eh3-catalog')){customElements.define('eh3-catalog',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const filters=this.querySelector('.eh3-filters');if(filters)filters.hidden=false;this.querySelectorAll('[data-open]').forEach(b=>b.hidden=false);this.addEventListener('click',e=>{const f=e.target.closest('[data-filter]');if(f){this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===f)));this.querySelectorAll('.eh3-card').forEach(c=>c.hidden=f.dataset.filter!=='all'&&c.dataset.category!==f.dataset.filter);}const open=e.target.closest('[data-open]');if(open){const d=document.getElementById(open.dataset.open);if(d)d.showModal();}if(e.target.closest('[data-close]'))e.target.closest('dialog').close();if(e.target.tagName==='DIALOG'){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}});document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)){this.querySelectorAll('.eh3-card').forEach(c=>c.hidden=false);this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter==='all')));}});}});}

  } catch(e) { console.error(e); }
})();
})();
